/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const GETPROJECTSBYUSERID= createAsyncThunk(
  "getProjectsByUserId/getProjectsByUserId",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getProjectsByUserIdSlice = createSlice({
  name: "getProjectsByUserIdSlice",
  initialState: {
    getProjectsByUserId: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetProjectsByUserId: (state) => {
        state.getProjectsByUserId.loading = false
        state.getProjectsByUserId.error = false
        state.getProjectsByUserId.data = []
        state.getProjectsByUserId.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETPROJECTSBYUSERID.fulfilled, (state, action) => {
      state.getProjectsByUserId = {
        ...state.getProjectsByUserId,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETPROJECTSBYUSERID.pending, (state, action) => {
      state.getProjectsByUserId = {
        ...state.getProjectsByUserId,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETPROJECTSBYUSERID.rejected, (state, action) => {
      state.getProjectsByUserId = {
        ...state.getProjectsByUserId,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getProjectsByUserIdAction = {
    GETPROJECTSBYUSERID,
};

export { getProjectsByUserIdAction };
export default getProjectsByUserIdSlice.reducer;
export const {setInitialStateOfgetProjectsByUserId} = getProjectsByUserIdSlice.actions